export const ADD_SUCCESS = 'Новый клиент добавлен';
export const ADD_ERROR = 'Не удалось добавить клиента';
